/**
 * Persist Ask Ev chat across route changes (e.g. open event preview → back).
 * sessionStorage so a new browser tab starts fresh; "New" clears deliberately.
 */

export interface AskEvStoredMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  events?: unknown[];
  pendingEdit?: unknown;
}

export interface AskEvChatSnapshot {
  messages: AskEvStoredMessage[];
  conversationId?: string;
  /** Open edit proposal (Confirm/Cancel) — keep across preview navigation */
  pendingEdit?: unknown;
  updatedAt: number;
}

const STORAGE_KEY = "eventox_ask_ev_chat_v1";

export function loadAskEvChat(): AskEvChatSnapshot | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AskEvChatSnapshot;
    if (!parsed || !Array.isArray(parsed.messages)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveAskEvChat(snapshot: Omit<AskEvChatSnapshot, "updatedAt">) {
  try {
    const payload: AskEvChatSnapshot = {
      ...snapshot,
      updatedAt: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // quota / private mode — ignore
  }
}

export function clearAskEvChat() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

